module.exports = __webpack_public_path__ + "img/idea.4869b5d6.svg";